<template>
  <v-card
    id="encours"
    fluid
  >
      <v-card-title class="justify-center">

            <span class="headline blue--text text--darken-2 text-center" >
                Extinction En Direct
            </span>

      </v-card-title>
  
<v-banner></v-banner>
<v-card> 
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="Heure (TU)"
        v-model="h_tu"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Heure (ST)"
        v-model="h_st"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Date"
        v-model="date"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
    </v-col>
  </v-row>

  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="Ra"
        v-model="ra"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Dec"
        v-model="dec"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Ah"
        v-model="ah"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
    </v-col>
  </v-row>

  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="Sextractor"
        v-model="sextra"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Tyco"
        v-model="tyco"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Match"
        v-model="match"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Atténuation"
        v-model="attenuation"
      ></v-text-field>
    </v-col>
  </v-row>

</v-card>


</v-card>
</template>
<script>
  
  export default {
    data: () =>({
      sky:{
        Mesure:{"last":{"id":3676128,"ts":"0000-00-00T00:00:00.000Z","st":"00h00m00s","ah":"-00h00m00s","am":1,"fname":"/var/www/data/2023-02-07/Skyprobe_2023-02-07_20-24-37.fits","ra":0.0000 ,"dec":0.0000,"nsex":0,"nty":0,"nm":0,"etd":-0.0000,"etf":-0.00000,"res":10},"dm":[], "h":[], "j":[]},
        
      },
      title: "SKYPROBE",
      dialog:"",
      search:"",
      h_tu : "",
      h_st :"",
      date : "",
      ra :"",
      dec :"",
      ah :"",
      sextra :"",
      tyco :"",
      match :" ",
      attenuation :"",
      A_Update_mesure : null,

    }),
    initialize(){

    },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

    this.get_Mesure();
    this.load_Mesure();
    this.A_Update_mesure = setInterval(() => {
      this.get_Mesure();
      this.load_Mesure();
    },2000);
  },

  methods: {

    get_Mesure(){

      const othis = this;


      this.axios.get( backend_url + "/Skyprobe/Mesure")
      .then((res) => {

          if(res.data.message != " "){

          }else{
            othis.sky.Mesure = JSON.parse(JSON.stringify(res.data));
          }
          
          
      })
      .catch(() => {
        console.log("PB with load Mesure");
      });

    },
    load_Mesure(){


      var tu = this.sky.Mesure.last.ts.split("T");
      var tmp1_tu = tu;

      this.date = tu[0];
      this.h_tu =  tu[1].split(".")[0];
      this.h_st = this.sky.Mesure.last.st;

      this.ra = this.sky.Mesure.last.ra;
      this.dec = this.sky.Mesure.last.dec;
      this.ah = this.sky.Mesure.last.ah;
      this.sextra = this.sky.Mesure.last.nsex;
      this.tyco =  this.sky.Mesure.last.nty;
      if(this.sky.Mesure.last.nm == null){
        this.match = 0;
      }else{
        this.match = this.sky.Mesure.last.nm;
      }
      //console.log( this.sky.Mesure.last);
      //console.log(this.match);
      this.attenuation = this.sky.Mesure.last.res;





      /*var t_targets = [];
      var the_target = this.tel.targets[0];
      for(var target of this.tel.targets){
        t_targets.push(target);
      };
      if(t_targets && t_targets.length > 0){
        console.log(t_targets[0]);
        this.objet = t_targets[0].objet;
        this.alpha = t_targets[0].alpha;        
        this.delta = t_targets[0].delta;
        this.magv = t_targets[0].magv;
      }*/
      
      //this.target = JSON.parse(JSON.stringify(t_targets));
      //console.log(this.target);
    },

  }
}
</script>